export default "__VITE_ASSET__CALV1O08__";